import baseRoute from '../baseRoute';

export type * from './requestModel';

type RouteDefinition = `${typeof baseRoute}/edit/${number | ':id'}`;

export const ROUTE: RouteDefinition = `${baseRoute}/edit/:id`;

export const URL = (id: number): RouteDefinition => `${baseRoute}/edit/${id}`;
